var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c('CommonHeader'),_c('router-view'),_c('CommonFooter'),(!_vm.isMobile)?_c('ReturnTop'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }